import React from "react";
import { View } from "react-native";
import { Checkbox, HelperText } from "react-native-paper";
import { useTranslation } from "react-i18next";

import {Field} from "../../config/companies/config";

interface CheckboxFieldProps {
  field: Field;
  value: boolean;
  onChange: (fieldName: string, newValue: any) => void;
  errors?: { [key: string]: string };
}

export const CheckboxField = ({
  field,
  value,
  onChange,
  errors = {},
}: CheckboxFieldProps) => {
  const { t } = useTranslation();
  const label = t(field.label) + (field.required ? "*" : "");

  return (
    <View>
      <Checkbox.Item
        label={label}
        status={value ? "checked" : "unchecked"}
        onPress={() => onChange(field.name, !value)}
      />
      {errors[field.name] && (
        <HelperText type="error">{t(errors[field.name])}</HelperText>
      )}
    </View>
  );
};
